import ErrorTitle from '@/components/errorTitle';
import { authClient } from '@/lib/auth-client';
import { getErrorDetails, matchError } from '@/lib/errors';
import { Alert, Button, Container } from '@mantine/core';
import { IconExclamationCircle } from '@tabler/icons-react';

export interface ErrorAlertProps {
  error: unknown;
}

export default function ErrorAlert({ error }: ErrorAlertProps) {
  const { title = 'An error occured', message } = matchError(error);
  const { data: session } = authClient.useSession();
  const errorDetails = getErrorDetails(error, session?.user);

  return (
    <Container
      my="md"
      css={{
        flex: 1,
        display: 'flex',
        justifyContent: 'center',
        alignItems: 'center',
      }}
    >
      <Alert color="red" icon={<IconExclamationCircle />} title={<ErrorTitle error={errorDetails}>{title}</ErrorTitle>}>
        <div
          css={{
            margin: '10px 0',
            maxHeight: '5em',
            overflowY: 'auto',
            whiteSpace: 'pre-wrap',
          }}
        >
          {message}
        </div>

        <Button onClick={() => window.location.reload()}>Reload Page</Button>
      </Alert>
    </Container>
  );
}
